import Styled from 'styled-components';

import { colorBlackberry45 } from '../../../lib/StyledComponents/Theme/amountCommon';

export const MenuItem = Styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  text-transform: capitalize;
  color: ${colorBlackberry45};
  padding: 0.75em 0;
  font-size: 1.4rem;
  cursor: pointer;

  & a,
  button {
    color: ${colorBlackberry45};

    &:hover {
      color: ${({ theme: { colorWhite } }) => colorWhite};
    }
  }
`;
